import type { ReactElement } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import { FiltersChip } from "app/pages/sales-intelligence/common-components/filters-panel";
import type { IRange } from "app/pages/sales-intelligence/types/range";

import type { IFilterViewBaseModelProps } from "../../../types/filterInstance";
import type { DynamicNumberRangeOptions } from "../../../types/filterOptions";
import { composeFieldChipLabel } from "../../../utils/filterOptions";
import { getFormattedRangeValue } from "../../../utils/rangeValueFormatters";

const NumberRangeFilterResult = ({
    filter: {
        options: { label, buckets, formatValue },
    },
    value,
    isActionEnabled = true,
    onGetLifecycleStatus,
    onFilterUpdate,
    onFilterValueRemove,
}: IFilterViewBaseModelProps<Partial<IRange<number>>, DynamicNumberRangeOptions>): ReactElement | null => {
    if (!value || (value.from == null && value.to == null)) {
        return null;
    }

    return (
        <Flex>
            <FiltersChip
                text={composeFieldChipLabel(label, getFormattedRangeValue(formatValue, buckets, value))}
                hideActionButton={!isActionEnabled}
                chipStatus={onGetLifecycleStatus?.(value)}
                onClose={() => {
                    onFilterValueRemove?.();
                    onFilterUpdate();
                }}
            />
        </Flex>
    );
};

export default NumberRangeFilterResult;
